import React from 'react';
import PropTypes from 'prop-types';
import './styles/search_dropdown.scss';

class ListItem extends React.Component {
  getUrl() {
    const { slug, type } = this.props;
    switch (type) {
      case 'organization':
        return `/organizations/${slug}`;
      default:
        return `/${slug}`;
    }
  }

  render() {
    const { name, type } = this.props;

    return (
      <li
        className={`search-dropdown__item search-dropdown__item--${type}`}
        data-testid="search-dropdown-list-item"
      >
        <a href={this.getUrl()} data-testid="search-dropdown-list-item-link">
          {name}
        </a>
        {`${type}` === 'organization' ? <span className="org-label" data-testid="search-dropdown-org-label">Org</span> : ''}
      </li>
    );
  }
}

ListItem.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'organization',
    'brandfolder',
    'collections'
  ])
};

export default ListItem;
